import React, { Fragment, useCallback, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

const DEFAULT_IMAGES = [
    '/assets/img/work/solution-01.jpg',
    '/assets/img/work/solution-02.jpg',
    '/assets/img/work/solution-03.jpg',
    '/assets/img/work/solution-04.jpg',
    '/assets/img/work/solution-05.jpg',
    '/assets/img/work/solution-06.jpg',
]

/**
 * @param {{ images?: string[], imageAlts?: string[], masonryClassName?: string, gridItemClassNames?: string[], enableLightbox?: boolean }} [props] enableLightbox 기본 false — 필요한 상세에서만 true
 */
const ProjectMasonryTwo = (props = {}) => {
    const { images, imageAlts, masonryClassName, gridItemClassNames, enableLightbox = false } = props
    const list = images?.length ? images : DEFAULT_IMAGES
    const masonryClasses = ['gx-4', 'mb-30', masonryClassName].filter(Boolean).join(' ')

    const [lightboxIndex, setLightboxIndex] = useState(null)

    const closeLightbox = useCallback(() => {
        setLightboxIndex(null)
    }, [])

    useEffect(() => {
        if (lightboxIndex === null) return undefined
        const onKeyDown = (e) => {
            if (e.key === 'Escape') closeLightbox()
        }
        document.addEventListener('keydown', onKeyDown)
        const prevOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        return () => {
            document.removeEventListener('keydown', onKeyDown)
            document.body.style.overflow = prevOverflow
        }
    }, [lightboxIndex, closeLightbox])

    const lightboxSrc = lightboxIndex !== null ? list[lightboxIndex] : null
    const lightboxAlt =
        lightboxIndex !== null ? imageAlts?.[lightboxIndex] ?? `프로젝트 구축 화면 ${lightboxIndex + 1}` : ''

    const lightboxPortal =
        enableLightbox &&
        lightboxIndex !== null &&
        typeof document !== 'undefined' &&
        createPortal(
            <div
                className="project-masonry-two-lightbox"
                role="dialog"
                aria-modal="true"
                aria-label="이미지 확대 보기"
                onClick={closeLightbox}
            >
                <div className="project-masonry-two-lightbox__panel" onClick={(e) => e.stopPropagation()}>
                    <button
                        type="button"
                        className="project-masonry-two-lightbox__close"
                        onClick={closeLightbox}
                        aria-label="닫기"
                    >
                        ×
                    </button>
                    <img className="project-masonry-two-lightbox__img" src={lightboxSrc} alt={lightboxAlt} decoding="async" />
                </div>
            </div>,
            document.body
        )

    return (
        <Fragment>
            <div className={`row gx-4 ${masonryClasses}`}>
                {list.map((src, i) => {
                    const alt = imageAlts?.[i] ?? `프로젝트 구축 화면 ${i + 1}`
                    return (
                        <div
                            key={i}
                            className={['col-lg-4 col-md-6', 'grid-item', gridItemClassNames?.[i]]
                                .filter(Boolean)
                                .join(' ')}
                        >
                            {enableLightbox ? (
                                <button
                                    type="button"
                                    className="project-masonry-two__lightbox-trigger"
                                    onClick={() => setLightboxIndex(i)}
                                    aria-label={`${alt} 확대 보기`}
                                >
                                    <img className="w-100" src={src} alt={alt} loading="lazy" decoding="async" />
                                </button>
                            ) : (
                                <img className="w-100" src={src} alt={alt} loading="lazy" decoding="async" />
                            )}
                        </div>
                    )
                })}
            </div>
            {lightboxPortal}
        </Fragment>
    )
}

export default ProjectMasonryTwo
